import { getLocale } from "../runtime";

const da_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Udforsk forskellige anvendelsesområder for vores produkter på Glimja`
};

const en_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explore different use cases for our products at Glimja`
};

const es_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Explora diferentes casos de uso para nuestros productos en Glimja`
};

const fi_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Tutustu erilaisiin käyttötarkoituksiin tuotteillemme Glimjalla`
};

const nb_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforsk ulike bruksområder for våre produkter på Glimja`
};

const sv_usecasesdescription = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Utforska olika användningsområden för våra produkter på Glimja`
};

const usecasesdescription = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_usecasesdescription(inputs)
	if (locale === "en") return en_usecasesdescription(inputs)
	if (locale === "es") return es_usecasesdescription(inputs)
	if (locale === "fi") return fi_usecasesdescription(inputs)
	if (locale === "nb") return nb_usecasesdescription(inputs)
	if (locale === "sv") return sv_usecasesdescription(inputs)
	return "useCasesDescription";
};

export { usecasesdescription as "useCasesDescription" };